import { motion } from "framer-motion";
import { Eye, Heart, Ear, Sparkles, Waves, Feather } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { MODALITIES } from "@/lib/content";

const ICONS = { clairvoyance: Eye, clairsentience: Heart, clairaudience: Ear, channeling: Sparkles, empathic: Waves, mediumship: Feather };
const SPANS = {
  clairvoyance: "lg:col-span-2", clairsentience: "lg:col-span-2",
  clairaudience: "lg:col-span-2", channeling: "lg:col-span-2",
  empathic: "lg:col-span-3", mediumship: "lg:col-span-3",
};

const Tile = ({ m, i }) => {
  const Icon = ICONS[m.k];
  return (
    <motion.div data-testid={`modality-${m.k}`} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.9, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }} whileHover={{ y: -4 }}
      className={`group sm:col-span-1 ${SPANS[m.k]} rounded-[24px] bg-[#FBFBF8] border border-[#E6E0D4] p-7 flex flex-col justify-between min-h-[210px] hover:border-[#C9B9A3] transition-colors`}>
      <div className="flex items-start justify-between">
        <Icon className="text-[#A8613C]" size={22} strokeWidth={1.4} />
        <span className="text-xs uppercase tracking-[0.2em] text-[#6E685F]">{m.sub}</span>
      </div>
      <div>
        <h4 className="font-display text-3xl text-[#2D2A26]">{m.name}</h4>
        <p className="mt-2 text-sm text-[#5E584F] leading-relaxed">{m.text}</p>
      </div>
    </motion.div>
  );
};

export const Modalities = () => (
  <section data-testid="modalities-bento" className="py-24 sm:py-32 bg-[#F4F0E8]">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
      <Reveal><Overline>Reading modalities</Overline></Reveal>
      <Reveal delay={0.1}><h2 className="mt-5 mb-14 font-display font-light text-4xl sm:text-5xl lg:text-6xl text-[#2D2A26] max-w-3xl">Six ways Spirit speaks through a reading.</h2></Reveal>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 lg:grid-rows-[repeat(3,minmax(210px,auto))] gap-4">
        <Reveal className="sm:col-span-2 lg:col-span-2 lg:row-span-2 relative overflow-hidden rounded-[24px] min-h-[320px]">
          <img src="/img/autumn.jpg" alt="Tarot cards among autumn leaves" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#2D2A26]/80 via-transparent to-transparent" />
          <p className="absolute bottom-7 left-7 right-7 font-display text-3xl text-[#FBFBF8] leading-tight">Uncover present circumstances, challenges and opportunities.</p>
        </Reveal>
        {MODALITIES.map((m, i) => <Tile key={m.k} m={m} i={i} />)}
      </div>
    </div>
  </section>
);
